import { TYPES } from "../actions";

const initialState = {
  scanPersons: [],
  totalCount: 0,
  currentScanPerson: null,
  loading: false,
  error: null
};

const tkt1ScanPersonReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get TKT1 Scan Persons
    case TYPES.ACTION_GET_TKT1_SCAN_PERSONS_SUCCESS:
      return {
        ...state,
        scanPersons: action.payload.data.data || [],
        totalCount: action.payload.data.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_SCAN_PERSONS_FAIL:
      return {
        ...state,
        scanPersons: [],
        loading: false,
        error: action.payload
      };

    // Get TKT1 Scan Person by ID
    case TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_ID_SUCCESS:
      return {
        ...state,
        currentScanPerson: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_ID_FAIL:
      return {
        ...state,
        currentScanPerson: null,
        loading: false,
        error: action.payload
      };

    // Get TKT1 Scan Person by MID
    case TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_MID_SUCCESS:
      return {
        ...state,
        currentScanPerson: action.payload.data,
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_TKT1_SCAN_PERSON_BY_MID_FAIL:
      return {
        ...state,
        currentScanPerson: null,
        loading: false,
        error: action.payload
      };

    // Search TKT1 Scan Persons
    case TYPES.ACTION_SEARCH_TKT1_SCAN_PERSONS_SUCCESS:
      return {
        ...state,
        scanPersons: action.payload.data.data || [],
        totalCount: action.payload.data.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    case TYPES.ACTION_SEARCH_TKT1_SCAN_PERSONS_FAIL:
      return {
        ...state,
        scanPersons: [],
        loading: false,
        error: action.payload
      };

    // Create TKT1 Scan Person
    case TYPES.ACTION_CREATE_TKT1_SCAN_PERSON_SUCCESS:
      return {
        ...state,
        scanPersons: [action.payload.data, ...state.scanPersons],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    case TYPES.ACTION_CREATE_TKT1_SCAN_PERSON_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update TKT1 Scan Person
    case TYPES.ACTION_UPDATE_TKT1_SCAN_PERSON_SUCCESS:
      return {
        ...state,
        scanPersons: state.scanPersons.map(item =>
          item._id === action.payload.data._id ? action.payload.data : item
        ),
        currentScanPerson: state.currentScanPerson && state.currentScanPerson._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentScanPerson,
        loading: false,
        error: null
      };
    case TYPES.ACTION_UPDATE_TKT1_SCAN_PERSON_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete TKT1 Scan Person
    case TYPES.ACTION_DELETE_TKT1_SCAN_PERSON_SUCCESS:
      return {
        ...state,
        scanPersons: state.scanPersons.filter(item => item._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentScanPerson: state.currentScanPerson && state.currentScanPerson._id === action.payload.id 
          ? null 
          : state.currentScanPerson,
        loading: false,
        error: null
      };
    case TYPES.ACTION_DELETE_TKT1_SCAN_PERSON_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default tkt1ScanPersonReducer;
